import styled from 'styled-components';

import Box from '../Box';

export const PageContainer = styled(Box)`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  @media (max-width: 480px) {
    height: auto;
  }
`;

export const MainContainer = styled.main`
  flex-grow: 1;
  align-self: stretch;
  overflow: hidden;
  @media (min-width: 740px) {
    width: calc(100vw - 280px);
  }
`;

export const DesktopContainer = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  max-width: 100vw;
`;
